import React, { useState, useEffect } from 'react';

import { Grid, Typography } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';

import Header from 'on_web/components/shared/Menu/Header/Header';
import ReportsBottomNavigation from 'on_web/components/shared/ReportsBottomNavigation/ReportsBottomNavigation';
import ReportsOpenTextSection from 'on_web/components/shared/ReportsOpenTextSection/ReportsOpenTextSection';
import PageItemContainer from 'on_web/components/shared/Common/PageItemContainer/PageItemContainer';
import DesktopMenu from 'on_web/components/shared/Menu/DesktopMenu/DesktopMenu';
import ErrorMessageTile from 'on_web/components/shared/ErrorMessageTile/ErrorMessageTile';
import CustomDialog from 'on_web/components/shared/CustomDialog/CustomDialog';

import Box from '@material-ui/core/Box';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';

import {
  recommendationLowRisk,
  recommendationHighRisk,
  recommendationModerateRisk,
  recommendationCriticalRisk,
  socialDistance,
  soap,
  washHands,
  socialInteraction,
  faceMask,
  seriousSymptoms,
  lessCommonSymptoms,
  commonSymptoms,
  stayInformed,
  routine,
  connectWithOthers,
  healthyDiet,
  exerciseRegularly,
  relaxationTechniques,
  getRest,
  stayHome,
  work,
} from 'on_web/assets/imageList';
import {
  LOW_RISK_COLOR,
  SEVERE_RISK_COLOR,
  CRITICAL_RISK_COLOR,
} from 'colours';

import { useTranslation, Trans } from 'react-i18next';

import useUsersApi from '../hooks/useUsersApi';
import { reportsBottomNavigationOptions } from 'on_web/helpers/redirectHelper';
import { getUserMetadata } from '../pce_legacy/src/helpers/clientStorageHelper';
import { mapRoutesToMenuItems } from 'on_web/helpers/menuItems';

import useCheckScreenSize from 'on_web/hooks/useCheckScreenSize';
import { trackEvent } from 'on_web/helpers/userTrackingEventsHelper';
import { parseHealthRisks, parseLikelihood } from 'on_web/helpers/risksHelper';
import { createMarkup } from 'on_web/helpers/customHelpers';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

function TabPanel1() {
  const { t } = useTranslation();

  const tabPanel1Content = [
    {
      image: washHands,
      text: t('reporting.assessmentRecommendations.washHands'),
    },
    {
      image: soap,
      text: t('reporting.assessmentRecommendations.soap'),
    },
    {
      image: faceMask,
      text: t('reporting.assessmentRecommendations.faceMask'),
    },
    {
      image: socialDistance,
      text: t('reporting.assessmentRecommendations.socialDistance'),
    },
  ];

  return (
    <Box mt={2}>
      <ReportsOpenTextSection
        title={t('reporting.assessmentRecommendations.keepSafeTitle')}
        contentItems={[
          tabPanel1Content.map((item, ix) => {
            return (
              <Box
                id={ix}
                display="flex"
                justifyContent="flex-start"
                alignItems={'flex-start'}
                mt={2}
              >
                <Box mt={{ xs: '-10px', sm: '-10px' }} mr={1}>
                  <img src={item.image} alt="icon" />
                </Box>
                <Typography
                  variant={'body3'}
                  style={{ fontSize: '14px' }}
                  dangerouslySetInnerHTML={createMarkup(item.text)}
                ></Typography>
              </Box>
            );
          }),
        ]}
      ></ReportsOpenTextSection>
    </Box>
  );
}

function TabPanel2(responseHealthBasedRisks) {
  const { t } = useTranslation();

  const getRecommendations = key => {
    return t(key, { returnObjects: true });
  };

  const tabPane2Content = [
    {
      image: commonSymptoms,
      title: t('reporting.assessmentRecommendations.mostCommonSymptomsTitle'),
      text: getRecommendations(
        'reporting.assessmentRecommendations.mostCommonSymptoms'
      ),
    },
    {
      image: lessCommonSymptoms,
      title: t('reporting.assessmentRecommendations.lessCommonSymptomsTitle'),
      text: getRecommendations(
        'reporting.assessmentRecommendations.lessCommonSymptoms'
      ),
    },
    {
      image: seriousSymptoms,
      title: t('reporting.assessmentRecommendations.seriousSymptomsTitle'),
      text: getRecommendations(
        'reporting.assessmentRecommendations.seriousSymptoms'
      ),
    },
  ];

  const tabPane2Content2 = [
    {
      image: seriousSymptoms,
      text: [
        t('reporting.assessmentRecommendations.doNotVisit'),
        t('reporting.assessmentRecommendations.doNotLeave'),
        t('reporting.assessmentRecommendations.takeCare'),
        t('reporting.assessmentRecommendations.takeOver'),
        t('reporting.assessmentRecommendations.stayInTouch'),
      ],
    },
  ];

  const renderSymptoms = items => {
    return (
      <Box>
        {items.map((element, ix) => {
          return (
            <Box id={ix} mt={1}>
              <Typography
                variant={'body3'}
                style={{ fontSize: '14px' }}
                dangerouslySetInnerHTML={createMarkup(element)}
              ></Typography>
            </Box>
          );
        })}
      </Box>
    );
  };

  const useSymptomsStyles = makeStyles(theme => ({
    symptomsTitle: {
      color: '#33b0ce',
      fontWeight: 'bold',
    },
  }));

  const classesSymptoms = useSymptomsStyles();

  const getSymptomsRecommendations = responseHealthBasedRisks => {
    let risk =
      responseHealthBasedRisks && responseHealthBasedRisks.total_risk
        ? responseHealthBasedRisks.total_risk.level
        : 0;

    if (risk === 0)
      return 'reporting.assessmentRecommendations.symptomsRecommendationsLow';
    if (risk === 1)
      return 'reporting.assessmentRecommendations.symptomsRecommendationsSevere';
    if (risk === 2)
      return 'reporting.assessmentRecommendations.symptomsRecommendationsCritical';
  };

  return (
    <Box mt={2}>
      <Box
        style={{
          borderBottom: '1px Solid #efefef',
        }}
        mt={2}
        mb={2}
      >
        <ReportsOpenTextSection
          title={t('reporting.assessmentRecommendations.stayAlertTitle')}
          contentItems={[
            tabPane2Content.map((item, ix) => {
              return (
                <Box
                  id={ix}
                  display="flex"
                  justifyContent="flex-start"
                  alignItems={'flex-start'}
                  mt={2}
                  mb={3}
                >
                  <Box mt={{ xs: '-10px', sm: '-10px' }} mr={1}>
                    <img src={item.image} alt="icon" />
                  </Box>
                  <Box display="flex-column" fontSize={16}>
                    <Typography className={classesSymptoms.symptomsTitle}>
                      {item.title}
                    </Typography>
                    <Box>
                      <Typography className={classesSymptoms.symptomsText}>
                        {renderSymptoms(item.text)}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              );
            }),
          ]}
        ></ReportsOpenTextSection>
      </Box>
      <Box
        mt={2}
        display="flex-column"
        justifyContent="center"
        alignItems={'center'}
      >
        <Box textAlign="center">
          <img src={stayHome} alt="icon" />
        </Box>
        <ReportsOpenTextSection
          title={t('reporting.assessmentRecommendations.ifYouHaveTitle')}
          paragraphsKeys={getRecommendations(
            getSymptomsRecommendations(responseHealthBasedRisks)
          )}
        ></ReportsOpenTextSection>
      </Box>
    </Box>
  );
}

function TabPanel3() {
  const { t } = useTranslation();

  const tabPanel3Content = [
    {
      image: exerciseRegularly,
      title: t('reporting.assessmentRecommendations.exerciseRegularlyTitle'),
      text: t(
        'reporting.assessmentRecommendations.exerciseRegularlyTitleBodyText'
      ),
    },
    {
      image: healthyDiet,
      title: t('reporting.assessmentRecommendations.maintainHealthyDietTitle'),
      text: t(
        'reporting.assessmentRecommendations.maintainHealthyDietBodyText'
      ),
    },
    {
      image: connectWithOthers,
      title: t('reporting.assessmentRecommendations.connectWithOthersTitle'),
      text: t('reporting.assessmentRecommendations.connectWithOthersBodyText'),
    },
    {
      image: relaxationTechniques,
      title: t('reporting.assessmentRecommendations.relaxationTechniquesTitle'),
      text: t('reporting.assessmentRecommendations.relaxationTechniquesBody'),
    },
  ];

  const tabPanel3Content2 = [
    {
      image: routine,
      title: t('reporting.assessmentRecommendations.routineTitle'),
      text: t('reporting.assessmentRecommendations.routineBodyText'),
    },
    {
      image: stayInformed,
      title: t('reporting.assessmentRecommendations.stayInformedTitle'),
      text: t('reporting.assessmentRecommendations.stayInformedBodyText'),
    },
    {
      image: getRest,
      title: t('reporting.assessmentRecommendations.getEnoughSleepTitle'),
      text: t('reporting.assessmentRecommendations.getEnoughSleepBodyText'),
    },
  ];

  const renderParagraphs = content => {
    return (
      <Box>
        {content.map((item, ix) => {
          return (
            <ReportsOpenTextSection
              title={item.title}
              contentItems={[
                <Typography
                  variant={'body3'}
                  style={{ fontSize: '14px' }}
                  dangerouslySetInnerHTML={createMarkup(item.text)}
                ></Typography>,
              ]}
              leftImage={item.image}
              displayFlex
              fontColor="#33b0ce"
              leftImgHeight="84px"
              fontTitleSize="18px"
              fontTitleWeight="bold"
            ></ReportsOpenTextSection>
          );
        })}
      </Box>
    );
  };

  return (
    <Box>
      <Box mt={2}>
        <ReportsOpenTextSection
          title={t('reporting.assessmentRecommendations.copingWithStressTitle')}
          contentItems={[renderParagraphs(tabPanel3Content)]}
        ></ReportsOpenTextSection>
      </Box>
      <Box
        style={{
          borderBottom: '1px Solid #efefef',
        }}
        mt={2}
        mb={2}
      ></Box>
      <Box mt={2}>
        <ReportsOpenTextSection
          title={t('reporting.assessmentRecommendations.stayingMotivatedTitle')}
          contentItems={[renderParagraphs(tabPanel3Content2)]}
        ></ReportsOpenTextSection>
      </Box>
    </Box>
  );
}

export default function ReportsMyAssessment(props) {
  const [isDesktop] = useCheckScreenSize();

  const [{ errorSpareAssessments, getSpareAssessments }] = useUsersApi();
  const [responseHealthBasedRisks, setResponseHealthBasedRisks] = useState(
    null
  );
  const [healthBasedRisksObj, setHealthBasedRisksObj] = useState(null);
  const [likelihoodObj, setLikelihoodObj] = useState(null);
  const [responseLikelihood, setResponseLikelihood] = useState(null);

  useEffect(() => {
    if (
      props.location.state &&
      props.location.state.healthBasedRisks &&
      props.location.state.infectionLikelihood
    ) {
      setResponseHealthBasedRisks(props.location.state.healthBasedRisks);
      setHealthBasedRisksObj(
        parseHealthRisks(props.location.state.healthBasedRisks)
      );
      setResponseLikelihood(props.location.state.infectionLikelihood);
      setLikelihoodObj(
        parseLikelihood(props.location.state.infectionLikelihood, t)
      );
    } else {
      getSpareAssessments().then(resp => {
        if (resp) {
          setResponseHealthBasedRisks(resp.health_based_severity);
          setHealthBasedRisksObj(parseHealthRisks(resp.health_based_severity));
          setResponseLikelihood(resp.past_infection_likelihood);
          setLikelihoodObj(parseLikelihood(resp.past_infection_likelihood, t));
        }
      });
    }
  }, [getSpareAssessments]);

  const { t } = useTranslation();

  const useStyles = makeStyles(theme => ({
    sectionBullet: {
      marginTop: '8px',
      color: '#33b0ce',
    },
    sectionBulletContent: {
      color: '#222222',
    },
    uList: {
      paddingLeft: '20px',
    },
  }));

  const classes = useStyles();

  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    trackEvent(
      'Reporting',
      `Tab click ${
        newValue === 0
          ? 'STAYING SAFE'
          : newValue === 1
          ? 'SYMPTOMS'
          : 'WELLBEING'
      }`
    );
    setTabValue(newValue);
  };

  const StyledTab = withStyles(theme => ({
    root: {
      flexGrow: 1,
      backgroundColor: '#eaeaea',
      fontFamily: 'Museo',
      fontSize: '12px',
      fontWeight: 'bold',
      textAlign: 'center',
      color: '#2a343f',
      lineHeight: '14px',
      textTransform: 'none',
      '&$selected': {
        color: '#ffffff',
        backgroundColor: '#2fb9da',
      },
    },
    selected: {},
  }))(props => <Tab disableRipple {...props} />);

  const content2 = [
    t('reporting.assessmentRecommendations.avoidLargerGatherings'),
    t('reporting.assessmentRecommendations.shoppingGroceries'),
    t('reporting.assessmentRecommendations.ifSupermarketOffers'),
  ];

  const tabTitles = [
    t('reporting.assessmentRecommendations.tabTitle1'),
    t('reporting.assessmentRecommendations.tabTitle2'),
    t('reporting.assessmentRecommendations.tabTitle3'),
  ];

  const getHealthRiskLevelAssets = () => {
    let risk =
      responseHealthBasedRisks && responseHealthBasedRisks.total_risk
        ? responseHealthBasedRisks.total_risk.level
        : 0;

    let recommendation = '';
    if (responseHealthBasedRisks && responseHealthBasedRisks.recommendations) {
      recommendation =
        responseHealthBasedRisks.recommendations.summary &&
        responseHealthBasedRisks.recommendations.summary.length > 0
          ? responseHealthBasedRisks.recommendations.summary[0]
          : '';
    }

    let work = [];
    if (responseHealthBasedRisks && responseHealthBasedRisks.recommendations) {
      work =
        responseHealthBasedRisks.recommendations.work &&
        responseHealthBasedRisks.recommendations.work.length > 0
          ? responseHealthBasedRisks.recommendations.work
          : [];
    }

    let social = [];
    if (responseHealthBasedRisks && responseHealthBasedRisks.recommendations) {
      social =
        responseHealthBasedRisks.recommendations.social &&
        responseHealthBasedRisks.recommendations.social.length > 0
          ? responseHealthBasedRisks.recommendations.social
          : [];
    }

    if (risk === 0)
      return {
        title: recommendation,
        textColor: LOW_RISK_COLOR,
        image: recommendationLowRisk,
        workContent: work,
        socialContent: social,
      };
    if (risk === 1)
      return {
        title: recommendation,
        textColor: SEVERE_RISK_COLOR,
        image: recommendationModerateRisk,
        workContent: work,
        socialContent: social,
      };
    if (risk === 2)
      return {
        title: recommendation,
        textColor: CRITICAL_RISK_COLOR,
        image: recommendationCriticalRisk,
        workContent: work,
        socialContent: social,
      };
  };

  const getStateToTransfer = () => {
    return {
      healthBasedRisks: responseHealthBasedRisks,
      infectionLikelihood: responseLikelihood,
    };
  };

  return (
    <React.Fragment>
      <div style={{ display: 'flex' }}>
        {errorSpareAssessments ? (
          <CustomDialog
            open={errorSpareAssessments}
            onCloseButton={() => {
              window.location = '/';
            }}
            style={{ marginLeft: isDesktop ? '300px' : '0' }}
          >
            <ErrorMessageTile
              level="error"
              title={t('common.errorMessages.general.title')}
              message={t('common.errorMessages.general.message')}
              actionText={t('common.errorMessages.general.reloadAction')}
              onButtonClick={() => {
                window.location = '/';
              }}
            ></ErrorMessageTile>
          </CustomDialog>
        ) : (
          <>
            <DesktopMenu
              id={4}
              stateToTransferOnNavigation={getStateToTransfer()}
            />
            <Grid
              container={isDesktop}
              direction="row"
              justify="center"
              alignItems="center"
              style={{
                width: `calc(100% - ${isDesktop ? 300 : 0}px)`,
              }}
            >
              {responseHealthBasedRisks && (
                <PageItemContainer>
                  <Box
                    style={{
                      borderBottom: '1px Solid #efefef',
                    }}
                    mb={2}
                  >
                    {isDesktop === false && (
                      <Header
                        squeeze
                        title={t('reporting.myAssessment.recommendationsTitle')}
                        secondaryHeader
                        hasShareAction
                        mainMenuItems={t('common.menu.mainItems', {
                          returnObjects: true,
                        })}
                        extraMenuItems={mapRoutesToMenuItems(getUserMetadata())}
                      />
                    )}

                    <Box
                      style={{
                        borderBottom: '3px Solid #efefef',
                      }}
                      mt={3}
                    >
                      <ReportsOpenTextSection
                        title={getHealthRiskLevelAssets().title}
                        contentItems={[<Box></Box>]}
                        fontColor={getHealthRiskLevelAssets().textColor}
                        sectionTitleSecondary
                        displayFlex
                        rightImage={getHealthRiskLevelAssets().image}
                      ></ReportsOpenTextSection>
                    </Box>

                    <ReportsOpenTextSection
                      title={t('reporting.assessmentRecommendations.workTitle')}
                      contentItems={[
                        <ul className={classes.uList}>
                          {getHealthRiskLevelAssets().workContent.map(
                            (content, ix) => {
                              return (
                                <li key={ix} className={classes.sectionBullet}>
                                  <span
                                    className={classes.sectionBulletContent}
                                  >
                                    <Typography
                                      variant={'body3'}
                                      style={{ fontSize: '14px' }}
                                      dangerouslySetInnerHTML={createMarkup(
                                        content
                                      )}
                                    ></Typography>
                                  </span>
                                </li>
                              );
                            }
                          )}
                        </ul>,
                      ]}
                      displayFlex
                      leftImage={work}
                    ></ReportsOpenTextSection>

                    {getHealthRiskLevelAssets().socialContent && (
                      <ReportsOpenTextSection
                        title={t(
                          'reporting.assessmentRecommendations.socialInteractionsTitle'
                        )}
                        contentItems={[
                          <ul className={classes.uList}>
                            {getHealthRiskLevelAssets().socialContent.map(
                              (content, ix) => {
                                return (
                                  <li
                                    key={ix}
                                    className={classes.sectionBullet}
                                  >
                                    <span
                                      className={classes.sectionBulletContent}
                                    >
                                      <Typography
                                        variant={'body3'}
                                        style={{ fontSize: '14px' }}
                                        dangerouslySetInnerHTML={createMarkup(
                                          content
                                        )}
                                      ></Typography>
                                    </span>
                                  </li>
                                );
                              }
                            )}
                          </ul>,
                        ]}
                        displayFlex
                        leftImage={socialInteraction}
                      ></ReportsOpenTextSection>
                    )}

                    <Box>
                      <AppBar
                        position="static"
                        style={{
                          backgroundColor: '#ffffff',
                          boxShadow: 'none',
                        }}
                      >
                        <Tabs
                          value={tabValue}
                          onChange={handleTabChange}
                          aria-label="tabs"
                          variant="fullWidth"
                        >
                          {tabTitles.map((tabTitle, ix) => {
                            return (
                              <StyledTab label={tabTitle} id={`tab-${ix}`} />
                            );
                          })}
                        </Tabs>
                      </AppBar>
                      <TabPanel value={tabValue} index={0}>
                        {() => TabPanel1()}
                      </TabPanel>
                      <TabPanel value={tabValue} index={1}>
                        {() => TabPanel2(responseHealthBasedRisks)}
                      </TabPanel>
                      <TabPanel value={tabValue} index={2}>
                        {() => TabPanel3()}
                      </TabPanel>
                    </Box>

                    <ReportsBottomNavigation
                      selected={reportsBottomNavigationOptions.recommendations}
                      onSelected={val =>
                        props.history.push({
                          pathname: val,
                          state: getStateToTransfer(),
                        })
                      }
                      marginTop="65px"
                    />
                  </Box>
                </PageItemContainer>
              )}
            </Grid>
          </>
        )}
      </div>
    </React.Fragment>
  );
}
